import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { AddRestaurantRequest } from '@/types/request/AddRestaurantRequest';
import { queryClient } from '@/main.tsx';

const useRestaurantAdd = () => {
  const client = supabaseClient;

  const mutationFn = async (request: AddRestaurantRequest) => {
    return addRestaurant(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['restaurants'] });
    },
  });
};

export default useRestaurantAdd;

async function addRestaurant(client: SupabaseClient, request: AddRestaurantRequest): Promise<void> {
  const { data, error } = await client.from('restaurants').insert(request).select('id').maybeSingle();

  if (error) throw new Error(error.message);
  if (!data) throw new Error('Failed to add Restaurant.');

  return;
}
